import { useQuery } from '@tanstack/react-query';
import { useApi } from '../useApi';
import { controlKeys } from './controls.key';

export function useGetControl(inspectionId: string) {
  const getApi = useApi();

  const getControl = async () => {
    const api = await getApi();

    const res = await api.controlsFindOneByInspectionId(inspectionId);
    return res.data;
  };

  const query = useQuery({
    queryKey: controlKeys.findOne(inspectionId),
    queryFn: getControl,
  });

  return query;
}
